import { render, staticRenderFns } from "./SeniorManagement.vue?vue&type=template&id=62e1304a&scoped=true"
import script from "./SeniorManagement.vue?vue&type=script&lang=js"
export * from "./SeniorManagement.vue?vue&type=script&lang=js"
import style0 from "./SeniorManagement.vue?vue&type=style&index=0&id=62e1304a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e1304a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62e1304a')) {
      api.createRecord('62e1304a', component.options)
    } else {
      api.reload('62e1304a', component.options)
    }
    module.hot.accept("./SeniorManagement.vue?vue&type=template&id=62e1304a&scoped=true", function () {
      api.rerender('62e1304a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MerchantKYC/components/SeniorManagement.vue"
export default component.exports